import { AddButton } from "../../../../components/form-controls/button/add-button/add-button.component";
import { withShowIf } from "../../../../components/with-show-if/with-show-If.component";

import { AddContentButtonProps } from "./add-content-button.props";

export const AddContentButton = withShowIf(
  ({ buttonText, disabled, onClick }: AddContentButtonProps) => (
    <AddButton disabled={disabled} onClick={onClick} text={buttonText} />
  )
);
